import SlingTip from '@sdk/common/slingTip/SlingTip';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

export const TaxInfoTopTip = () => (
  <SlingTip isVisible>
    <Text14 semiBold themeColor={ThemeColorType.white}>
      {gettext(
        'Please be aware that your invoice will be adjusted to include sales tax based on your billing address.'
      )}
    </Text14>
  </SlingTip>
);
